// @import
import { ensureHTMLElement } from "@src/js/lib/ensure";
import { viewport } from "@src/js/lib/viewport";
import Alpine from "alpinejs";

Alpine.directive("card-film", (element, {}, { cleanup }) => {
  const dom = {
    detail: ensureHTMLElement(element.querySelector(".c-card-film-details")),
    parentHasAccent: element.closest("[data-accent]"),
  };

  let timeOutRemoveClone: NodeJS.Timeout;
  let timeOutOpen: NodeJS.Timeout;
  let timeOutClone: NodeJS.Timeout;

  // Clone detail to be able to display it outside of the card on hover, allowing more freedom for styling and avoiding overflow:hidden issues
  let clone = dom.detail.cloneNode(true) as HTMLElement;

  const sectionAccent = dom.parentHasAccent?.getAttribute("data-accent");
  if (sectionAccent) {
    clone.setAttribute("data-accent", sectionAccent);
  }

  // Get href before cloning because the clone don't have the href attribute
  const href = element.getAttribute("href");

  function handleClick(e: Event) {
    e.preventDefault();
    if (href) {
      window.location.href = href;
    }
  }

  function computeStyle() {
    const rect = element.getBoundingClientRect();
    clone.style.top = `${rect.top + window.scrollY - 0.2}px`;
    clone.style.left = `${rect.left + window.scrollX - 0.2}px`;
    clone.style.width = `${rect.width + 0.4}px`;
    clone.style.height = `${rect.height + 0.4}px`;
  }

  //  MouseEnter, add clone to body and position it on top of the card,
  // then add class to trigger animation
  function mouseEnter() {
    if (!element.closest(".is-in-view") || element.closest(".is-scrolling")) {
      return;
    }

    // if on mobile do nothing
    if (viewport.isTouch) {
      return;
    }

    if (timeOutRemoveClone) clearTimeout(timeOutRemoveClone);
    if (timeOutOpen) clearTimeout(timeOutOpen);
    if (timeOutClone) clearTimeout(timeOutClone);

    // Delelte any previous clone just in case and create a new one
    document.body.querySelectorAll(".c-card-film-details--open").forEach((el) => el.remove());

    timeOutClone = setTimeout(() => {
      if (!element.closest(".is-in-view") || element.closest(".is-scrolling")) {
        return;
      }
      computeStyle();
      clone.style.position = "absolute";
      clone.style.display = "block";
      clone.style.zIndex = "10";
      window.addEventListener("resize", computeStyle);
      window.addEventListener("scroll", mouseLeave);
      document.body.appendChild(clone);
    }, 10);

    timeOutOpen = setTimeout(() => {
      if (!element.closest(".is-in-view") || element.closest(".is-scrolling")) {
        return;
      }
      clone.classList.add("c-card-film-details--open");
    }, 40);
  }

  // On mouse leave, remove class to trigger animation then remove from dom after animation
  function mouseLeave() {
    if (timeOutOpen) clearTimeout(timeOutOpen);
    if (timeOutClone) clearTimeout(timeOutClone);
    if (timeOutRemoveClone) clearTimeout(timeOutRemoveClone);
    clone.classList.remove("c-card-film-details--open");
    timeOutRemoveClone = setTimeout(() => {
      window.removeEventListener("resize", computeStyle);
      window.removeEventListener("scroll", mouseLeave);
      clone.remove();
    }, 300);
  }

  element.addEventListener("mouseenter", mouseEnter);
  clone.addEventListener("mouseleave", mouseLeave);
  clone.addEventListener("click", handleClick);

  cleanup(() => {
    window.removeEventListener("resize", computeStyle);
    element.removeEventListener("mouseenter", mouseEnter);
    clone.removeEventListener("mouseleave", mouseLeave);
    clone.removeEventListener("click", handleClick);
  });
});
